import PropTypes from 'prop-types';
import React from 'react';
import { Card, Checkbox, Grid } from 'semantic-ui-react';
import { DthcActions, GlobalNotifications, Intent, TextEditor } from '../../../Modules';
import { FloatingLabelInput as Input } from '../../../Elements';
import Formsy from 'formsy-react';
import currencyFormatter from 'currency-formatter';
import NumberFormat from 'react-number-format';

export default class LibraryItemEditDesktop extends React.Component {
  static propTypes = {
    localService: PropTypes.object.isRequired,
    service: PropTypes.object.isRequired,
    commitUpdate: PropTypes.func,
    reset: PropTypes.func,
    delete: PropTypes.func,
    onChange: PropTypes.func,
    index: PropTypes.number,
    closeHandler: PropTypes.func,
    closeEditor: PropTypes.func,
    viewer: PropTypes.object,
    isNew: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      submitted: false
    };
    this.fieldChange = this.fieldChange.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.reset = this.reset.bind(this);
    this.delete = this.delete.bind(this);
    this.commitUpdate = this.commitUpdate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.priceFieldChange = this.priceFieldChange.bind(this);
    this.addToLibraryChange = this.addToLibraryChange.bind(this);
    this.descriptionFieldChange = this.descriptionFieldChange.bind(this);
  }

  componentDidMount() {
    if (this.refs.service.scrollIntoViewIfNeeded) this.refs.service.scrollIntoViewIfNeeded();
  }

  componentWillUnmount() {
    if (this.props.closeEditor) this.props.closeEditor();
  }

  onSubmit() {
    this.setState(() => ({ submitted: true }));
  }

  onValidSubmit() {
    this.props.commitUpdate(this.props.index, () => this.props.closeHandler());
  }

  onInvalidSubmit() {
    GlobalNotifications.show({
      message: 'Unable to add service',
      intent: Intent.DANGER
    });
  }

  commitUpdate(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ submitted: true });
    if (!this.props.isNew) {
      this.props.commitUpdate(this.props.index, () =>
        this.props.closeHandler()
      );
    }
  }

  reset(e) {
    this.props.reset(this.props.index);
    this.props.closeHandler(e);
    e.stopPropagation();
  }

  delete(e) {
    e.preventDefault();
    this.props.delete(this.props.index, () => this.props.closeHandler);
  }

  textFieldChange(e) {
    this.fieldChange(e.target.name, e.target.value);
  }

  fieldChange(key, value) {
    const newValue = {};
    newValue[key] = value;
    this.props.onChange(Object.assign(this.props.localService, newValue));
  }

  priceFieldChange(e) {
    this.fieldChange('price_cents', e.target.value * 100);
  }

  descriptionFieldChange(value) {
    this.fieldChange('description', value);
  }

  addToLibraryChange(e, data) {
    this.fieldChange('addToLibrary', data.checked);
  }

  render() {
    const service = this.props.localService;

    return (
      <Formsy.Form
        className='ui form'
        onValidSubmit={this.onValidSubmit}
        onInvalidSubmit={this.onInvalidSubmit}
        onSubmit={this.onSubmit}
      >
        <div ref='service'>
          <Card
            fluid
            style={{
              background: 'transparent',
              boxShadow: 'none',
              userSelect: 'none'
            }}
          >
            <Card.Content>
              <Grid style={{ marginTop: 0 }}>
                <Grid.Row style={{ paddingBottom: 0 }}>
                  <Grid.Column computer={8} tablet={8} mobile={16}>
                    <Input
                      fluid
                      rows={1}
                      placeholder='Service name'
                      value={service.title || ''}
                      onChange={this.textFieldChange}
                      name='title'
                      label='Service name'
                      submitted={this.state.submitted}
                      className='strong'
                      required
                      validationError='Service name is required'
                    />
                  </Grid.Column>
                  <Grid.Column width={3} only='computer tablet'>
                    <Input
                      name='price_cents'
                      type='currency'
                      placeholder='$500.00'
                      value={
                        service.price_cents ? service.price_cents / 100 : ''
                      }
                      onChange={this.priceFieldChange}
                      submitted={this.state.submitted}
                      required
                      label='Price'
                      validationError='Price is required'
                      className='textAlignRight'
                    >
                      <NumberFormat
                        thousandSeparator
                        prefix={'$'}
                        decimalScale={2}
                        fixedDecimalScale
                      />
                    </Input>
                  </Grid.Column>
                  <Grid.Column width={2} only='computer tablet'>
                    <Input
                      name='quantity'
                      label='Qty'
                      type='number'
                      placeholder='1'
                      value={service.quantity}
                      onChange={this.textFieldChange}
                      submitted={this.state.submitted}
                      className='textAlignRight'
                    />
                  </Grid.Column>
                  <Grid.Column
                    width={3}
                    textAlign='right'
                    only='computer tablet'
                  >
                    <p style={{ paddingTop: '0.5em' }}>
                      <strong>Total</strong>
                      <br />
                      {currencyFormatter.format(
                        (service.quantity || 1) *
                          (service.price_cents || 0) /
                          100,
                        {
                          code: service.price_currency
                        }
                      )}
                    </p>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ paddingTop: 0 }}>
                  <Grid.Column width={16}>
                    <TextEditor
                      onChange={this.descriptionFieldChange}
                      value={service.description || ''}
                      placeholder='Short description of item'
                    />
                    {this.props.isNew &&
                      <div>
                        <br />
                        <Checkbox
                          label='Save to library for future use'
                          checked={service.addToLibrary}
                          onChange={this.addToLibraryChange}
                          name='saveToLibrary'
                          submitted={this.state.submitted}
                        />
                      </div>}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <DthcActions
                id={this.props.service.id}
                reset={this.props.reset ? this.reset : undefined}
                delete={this.props.delete ? this.delete : undefined}
                isNew={this.props.isNew}
              />
            </Card.Content>
          </Card>
        </div>
      </Formsy.Form>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Library/LibraryItemEditDesktop.js